import request from '@/utils/request'
// 团队列表
export function teamList(data) {
  return request({
    url: '/sys/team/list',
    method: 'post',
    data
  })
}
// 团队添加
export function teamSaveAdd(data) {
  return request({
    url: '/sys/team/save',
    method: 'post',
    data
  })
}
// 团队编辑
export function teamUpdateEdit(data) {
  return request({
    url: '/sys/team/update',
    method: 'post',
    data
  })
}
// 组员列表
export function teamUser(data) {
  return request({
    url: '/sys/team/user',
    method: 'get',
    data
  })
}
// 团队详情
export function teamInfo(id) {
  return request({
    url: `/sys/team/info/${id}`,
    method: 'get'
  })
}
